module.exports = __webpack_public_path__ + "static/img/prototypes.61662d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/prototypes.png
// module id = 6TWF
// module chunks = 0